<template>
    <div class="form-header">
        <h3>{{title}}</h3>
        <hr />
    </div>
</template>

<script>
export default {
  props: ['newElementText', 'elementModel', 'elementName'],
  computed: {
      title() {
          return (this.elementName ? this.elementModel + ' ' + this.elementName : this.newElementText + ' ' + this.elementModel);
      }
  }
}
</script>

<style>
  .form-header {
    margin-top: 3%;
    margin-bottom: 2%;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/FormHeader.vue